module.exports = {"450503100":"福成镇","450503101":"银滩镇","450503102":"平阳镇","450503103":"侨港镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450503.json
// module id = 1943
// module chunks = 0